<template>
  <div class="tootip-box">
    <el-popover
      placement="top-start"
      trigger="hover"
      :content="item.tooTip.content"
    >
      <span slot="reference">
        <i
          :class="[
            item.tooTip.iconClass ? item.tooTip.iconClass : 'el-icon-info',
          ]"
          class="tooTip"
        ></i>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped>
.tootip-box {
  display: inline-block;
  position: absolute;
  top: 0px;
  left: -15px;
}
//   .tooTip {
//   position: absolute;
//   top: 8px;
//   left: -15px;
// }
</style>
